import "../../../Format";
import "./Vector";

/** @namespace GIS.Map.Layer.OL3 */
NS("GIS.Map.Layer.OL3");

/**
 * WFS Vector layer.
 * Implements WFS Web Map service layer.
 *
 * @class
 * @extends GIS.Map.Layer.OL3.Vector
 */
GIS.Map.Layer.OL3.WFS = Class(GIS.Map.Layer.OL3.Vector, /** @lends GIS.Map.Layer.OL3.WFS.prototype */{
    // options
    format: GIS.Format.GML3,
    params: {
        version: "2.0.0",
        typeName: null,
        filter: null,
        maxFeatures: null,
        propertyName: null,
        outputFormat: GIS.Format.GML3
    },
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat(["params"]);
    },
    /** @inheritDoc */
    prepareOptions(options)
    {
        const map = this.map;

        options = this.Parent(options);

        options.loader = (extent, resolution, projection) => {
            return this.GetFeature({
                bbox: map.transformExtentProjection(extent, projection, this.projection)
            }).then((response) => {
                assert(!!response, "Objects load failed!", RequestFailedError);
                return response;
            });
        };

        if (options.format != null) {
            _.set(options, "params.outputFormat", options.format);
        }

        return options;
    },
    /**
     * @returns {Promise}
     */
    GetCapabilities()
    {
        return Promise.reject(new NotImplementedError("not implemented"));
    },
    /**
     * @returns {string}
     */
    getGetCapabilitiesURL()
    {
        throw new NotImplementedError("not implemented");
    },
    /**
     * @param {Object} params
     * @returns {Promise}
     * todo implement through POST, encode params with OGC standard
     */
    GetFeature(params)
    {
        const options = {
            url: this.getGetFeatureURL(params),
            dataType: GIS.Format.dataType(this.params.outputFormat)
        };

        return Promise.resolve(Xhr.request(options, noop));
    },
    /**
     * @returns {string}
     */
    getGetFeatureURL(params)
    {
        params = _.defaults(
            _.omit(prepareWFSParams(params), 'VERSION'),
            prepareWFSParams(this.params)
        );

        params = {
            ...params,
            SERVICE: 'WFS',
            REQUEST: 'GetFeature',
            SRSNAME: this.projection
        };

        var urlParts = Util.String.urlParts(this.url);
        urlParts.search = Util.String.urlQueryString({
            ...Util.String.urlQueryParams(urlParts.search),
            ...params
        });

        return Util.String.urlBuild(urlParts);
    },

    prepareWFSParams
});

GIS.Map.Layer.OL3.WFS.Static(/** @lends GIS.Map.Layer.OL3.WFS */{
    prepareWFSParams
});

/**
 * Prepares WMS request params.
 * @param {Object} params
 * @returns {Object}
 * @static
 * @public
 * todo менять некоторые ключи в зависимости от версии
 * todo convert filters
 */
function prepareWFSParams(params)
{
    const wfsParams = ['version', 'typeName', 'filter', 'maxFeatures', 'propertyName', 'outputFormat', 'bbox'];
    const formatParams = ['outputFormat'];

    return _.chain(params).pickBy(value => Util.validateOption(value) != null)
        .reduce((result, value, name) => {
            if (_.includes(formatParams, name) && Util.isNumeric(value)) {
                value = GIS.Format.format(value);
            }

            if (_.includes(wfsParams, name)) {
                name = name.toUpperCase();
            }

            if (_.isArray(value)) {
                value = value.join(',');
            }

            result[name] = Util.String.coalesce(value);

            return result;
        }, {});
}
